import type { File as DocxFile, IParagraphStyleOptions } from 'docx';
import { keys } from 'ramda';

import { createRunProperties } from './internal';
import type { DocumentElement } from '../../../slate-api';
import { defaultStyles } from '../../../slate-api';

type IPropertiesOptions = ConstructorParameters<typeof DocxFile>[0];
export function createDocxStyles(document: DocumentElement): Pick<IPropertiesOptions, 'styles'> {
  const styleSheet = document.styleSheet ?? defaultStyles;

  return keys(styleSheet).reduce<Pick<IPropertiesOptions, 'styles'>>((newStyles, styleKey) => {
    const { fontStyle: displayName, styleVariant, styles } = styleSheet[styleKey];
    const paragraphStyles: IParagraphStyleOptions = {
      basedOn: 'Normal',
      id: styleVariant,
      name: displayName,
      next: 'Normal',
      quickFormat: true,
      run: {
        ...createRunProperties(styles),
      },
    };

    return {
      styles: {
        paragraphStyles: newStyles.styles?.paragraphStyles
          ? [...newStyles.styles.paragraphStyles, paragraphStyles]
          : [paragraphStyles],
      },
    };
  }, {});
}
